module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-It.6f115be.woff2";